// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jLnu","label":"styles_label__26xCL"};